import { render, staticRenderFns } from "./PostulacionForm.vue?vue&type=template&id=1382b7ce"
import script from "./PostulacionForm.vue?vue&type=script&lang=js"
export * from "./PostulacionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports